const Areas = {
  sf: "San Francisco",
  eastbay: "East Bay",
  southbay: "South Bay",
  marin: "Marin"
};

export default Areas;
